import {
  FETCH_API_KEYS_ATTEMPT,
  FETCH_API_KEYS_SUCCESS,
  FETCH_API_KEYS_ERROR,
  FETCH_API_KEYS_RESET_STATE,
  CREATE_API_KEY_ATTEMPT,
  CREATE_API_KEY_SUCCESS,
  CREATE_API_KEY_ERROR,
  CREATE_API_KEY_RESET_STATE,
  UPDATE_API_KEY_ATTEMPT,
  UPDATE_API_KEY_SUCCESS,
  UPDATE_API_KEY_ERROR,
  UPDATE_API_KEY_RESET_STATE,
  DELETE_API_KEY_ATTEMPT,
  DELETE_API_KEY_SUCCESS,
  DELETE_API_KEY_ERROR,
  DELETE_API_KEY_RESET_STATE,
} from "../actionTypes/actionTypes";

const initialState = {
  apiKeys: {
    data: [],
    perPage: 10,
    page: 1,
    total: 0,
    attempt: false,
    success: false,
    error: null,
  },
  createApiKey: {
    attempt: false,
    success: false,
    error: null,
    createdKey: null, // Stores the full key data (including key value) on creation
  },
  updateApiKey: {
    attempt: false,
    success: false,
    error: null,
  },
  deleteApiKey: {
    attempt: false,
    success: false,
    error: null,
  },
};

const apiKeysReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_API_KEYS_ATTEMPT:
      return {
        ...state,
        apiKeys: {
          ...state.apiKeys,
          attempt: true,
          success: false,
          error: null,
        },
      };
    case FETCH_API_KEYS_SUCCESS:
      return {
        ...state,
        apiKeys: {
          ...action.payload,
          attempt: false,
          success: true,
          error: null,
        },
      };
    case FETCH_API_KEYS_ERROR:
      return {
        ...state,
        apiKeys: {
          ...state.apiKeys,
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case FETCH_API_KEYS_RESET_STATE:
      return {
        ...state,
        apiKeys: {
          ...state.apiKeys,
          attempt: false,
          success: false,
          error: null,
        },
      };
    case CREATE_API_KEY_ATTEMPT:
      return {
        ...state,
        createApiKey: {
          attempt: true,
          success: false,
          error: null,
          createdKey: null,
        },
      };
    case CREATE_API_KEY_SUCCESS:
      return {
        ...state,
        createApiKey: {
          attempt: false,
          success: true,
          error: null,
          createdKey: action.payload,
        },
        apiKeys: {
          ...state.apiKeys,
          data: [action.payload, ...state.apiKeys.data],
          total: state.apiKeys.total + 1,
        },
      };
    case CREATE_API_KEY_ERROR:
      return {
        ...state,
        createApiKey: {
          attempt: false,
          success: false,
          error: action.payload,
          createdKey: null,
        },
      };
    case CREATE_API_KEY_RESET_STATE:
      return {
        ...state,
        createApiKey: {
          attempt: false,
          success: false,
          error: null,
          createdKey: null,
        },
      };
    case UPDATE_API_KEY_ATTEMPT:
      return {
        ...state,
        updateApiKey: {
          attempt: true,
          success: false,
          error: null,
        },
      };
    case UPDATE_API_KEY_SUCCESS:
      return {
        ...state,
        updateApiKey: {
          attempt: false,
          success: true,
          error: null,
        },
        apiKeys: {
          ...state.apiKeys,
          data: state.apiKeys.data.map((key) =>
            key.id === action.payload.id ? action.payload : key
          ),
        },
      };
    case UPDATE_API_KEY_ERROR:
      return {
        ...state,
        updateApiKey: {
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case UPDATE_API_KEY_RESET_STATE:
      return {
        ...state,
        updateApiKey: {
          attempt: false,
          success: false,
          error: null,
        },
      };
    case DELETE_API_KEY_ATTEMPT:
      return {
        ...state,
        deleteApiKey: {
          attempt: true,
          success: false,
          error: null,
        },
      };
    case DELETE_API_KEY_SUCCESS:
      return {
        ...state,
        deleteApiKey: {
          attempt: false,
          success: true,
          error: null,
        },
        apiKeys: {
          ...state.apiKeys,
          data: state.apiKeys.data.filter((key) => key.id !== action.payload.id),
          total: state.apiKeys.total - 1,
        },
      };
    case DELETE_API_KEY_ERROR:
      return {
        ...state,
        deleteApiKey: {
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case DELETE_API_KEY_RESET_STATE:
      return {
        ...state,
        deleteApiKey: {
          attempt: false,
          success: false,
          error: null,
        },
      };
    default:
      return state;
  }
};

export default apiKeysReducer;

